/* Simms Knits checkout page. Payment provider (Whop) mounts into #whop-checkout and reads
   window.SimmsCheckout.getOrder() or listens for the `simms:checkout:ready` event. */
(() => {
  const root = document.querySelector('[data-k-checkout]');
  if (!root || !root.querySelector('[data-k-co-form]')) return;
  const form = root.querySelector('[data-k-co-form]');
  const FREE = +root.dataset.free, STD = +root.dataset.std, EXP = +root.dataset.exp;
  const KEY = 'sk-checkout';
  const PAY_URL = root.dataset.payUrl || 'https://pay.simmsknitting.com/';
  const $ = (s) => root.querySelector(s);
  const money = (c) => '$' + (c % 100 === 0 ? (c / 100).toFixed(0) : (c / 100).toFixed(2));
  let cart = null;

  /* ---------- restore saved details ---------- */
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || '{}');
    Object.entries(saved).forEach(([k, v]) => {
      const el = form.elements[k];
      if (!el || v == null) return;
      if (el instanceof RadioNodeList) { [...el].forEach((r) => (r.checked = r.value === v)); }
      else if (el.type === 'checkbox') el.checked = !!v;
      else el.value = v;
    });
  } catch (e) {}

  const data = () => {
    const d = {};
    new FormData(form).forEach((v, k) => (d[k] = typeof v === 'string' ? v.trim() : v));
    d.marketing = form.elements.marketing.checked;
    return d;
  };
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify(data())); } catch (e) {} };
  form.addEventListener('input', save);
  form.addEventListener('change', save);

  /* ---------- totals ---------- */
  const shippingCost = () => {
    const m = form.elements.shipping.value;
    const base = cart ? cart.total_price : +($('[data-k-grand]').dataset.base || 0);
    if (m === 'express') return EXP;
    return base >= FREE ? 0 : STD;
  };
  // every discount on the cart, line-level (5% off 3+ pieces) and cart-level (codes), summed per title
  const discounts = () => {
    const by = new Map();
    const add = (t, c) => by.set(t, (by.get(t) || 0) + c);
    cart.items.forEach((i) => (i.line_level_discount_allocations || []).forEach((a) => add(a.discount_application.title, a.amount)));
    (cart.cart_level_discount_applications || []).forEach((d) => add(d.title, d.total_allocated_amount));
    return [...by].map(([title, cents]) => ({ title, cents }));
  };
  const renderTotals = () => {
    if (!cart) return;
    const ship = shippingCost();
    $('[data-k-subtotal]').textContent = money(cart.original_total_price);
    root.querySelectorAll('[data-k-discount-row]').forEach((r) => r.remove());
    const shipRow = $('[data-k-shipping]').parentElement;
    discounts().forEach((d) => {
      const row = document.createElement('div');
      row.setAttribute('data-k-discount-row', '');
      row.innerHTML = '<dt></dt><dd></dd>';
      row.firstChild.textContent = d.title;
      row.lastChild.textContent = '−' + money(d.cents);
      shipRow.before(row);
    });
    $('[data-k-shipping]').textContent = ship ? money(ship) : 'Free';
    $('[data-k-std-price]').textContent = cart.total_price >= FREE ? 'Free' : money(STD);
    const grand = cart.total_price + ship;
    $('[data-k-grand]').textContent = money(grand);
    root.querySelector('[data-k-total]').textContent = money(grand);
  };
  const renderItems = () => {
    const ul = $('[data-k-items]');
    ul.innerHTML = cart.items.map((i) => `
      <li class="k-co__item">
        <span class="k-co__thumb">${i.image ? `<img src="${i.image + (i.image.includes('?') ? '&' : '?') + 'width=160'}" alt="" loading="eager">` : ''}<span class="k-co__qty">${i.quantity}</span></span>
        <span class="k-co__iname">${i.product_title}${i.variant_title ? `<small>${i.variant_title}</small>` : ''}</span>
        <span class="k-co__iprice">${money(i.original_line_price)}</span>
      </li>`).join('');
  };
  const codeMsg = () => {
    const el = $('[data-k-codemsg]');
    const c = (cart.discount_codes || [])[0];
    el.textContent = c ? (c.applicable ? `${c.code} applied` : `${c.code} can't be used on this order`) : '';
    el.classList.toggle('is-bad', !!(c && !c.applicable));
    const input = root.querySelector('#co-code');
    if (c && !input.value) input.value = c.code;
  };
  const loadCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => {
    cart = c;
    if (!c.item_count) { window.location.reload(); return; }
    renderItems(); renderTotals(); codeMsg();
    window.SimmsCheckout.cart = c;
  });

  /* ---------- discount code ---------- */
  $('[data-k-co-code]').addEventListener('submit', (e) => {
    e.preventDefault();
    const btn = e.target.querySelector('button');
    btn.setAttribute('aria-disabled', 'true');
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: e.target.elements.code.value.trim() }) })
      .then(loadCart).finally(() => btn.removeAttribute('aria-disabled'));
  });

  /* ---------- validation + continue ---------- */
  const fieldOk = (el) => {
    let ok = el.checkValidity();
    if (el.name === 'email') ok = ok && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(el.value.trim());
    const wrap = el.closest('.k-field');
    if (wrap) { wrap.classList.toggle('is-bad', !ok); const m = wrap.querySelector('.k-field__err'); if (m) m.hidden = ok; }
    el.setAttribute('aria-invalid', ok ? 'false' : 'true');
    return ok;
  };
  form.addEventListener('focusout', (e) => { if (e.target.matches('input[required], select[required]') && e.target.value) fieldOk(e.target); });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const req = [...form.querySelectorAll('input[required], select[required]')];
    const bad = req.filter((el) => !fieldOk(el));
    if (bad.length) { bad[0].focus(); return; }
    save();
    const d = data();
    const btn = form.querySelector('[data-k-co-continue]');
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = 'Opening secure payment…';
    const go = () => {
      const order = window.SimmsCheckout.getOrder();
      document.dispatchEvent(new CustomEvent('simms:checkout:ready', { detail: order }));
      const bytes = new TextEncoder().encode(JSON.stringify(order));
      let bin = ''; bytes.forEach((b) => (bin += String.fromCharCode(b)));
      const payload = btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      window.location.href = PAY_URL + '#o=' + payload;
    };
    // carry the delivery details with the cart as well, then hand off
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _delivery: JSON.stringify(d) } }) }).then(loadCart).catch(() => {}).finally(go);
  });

  form.addEventListener('change', (e) => { if (e.target.name === 'shipping') renderTotals(); });

  /* ---------- phone summary toggle ---------- */
  const toggle = root.querySelector('[data-k-co-toggle]');
  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    root.querySelector('[data-k-co-panel]').classList.toggle('is-open', open);
  });

  /* ---------- public hook for the payment provider ---------- */
  window.SimmsCheckout = {
    cart: null,
    getOrder() {
      const d = data();
      const ship = shippingCost();
      return {
        email: d.email, marketing: d.marketing,
        shipping_address: { first_name: d.first_name, last_name: d.last_name, address1: d.address1, address2: d.address2,
          city: d.city, province: d.province, zip: d.zip, country: d.country, phone: d.phone },
        shipping_method: d.shipping, shipping_cents: ship,
        cart_token: cart && cart.token,
        line_items: cart ? cart.items.map((i) => ({ variant_id: i.variant_id, quantity: i.quantity, title: i.product_title, variant_title: i.variant_title, line_cents: i.original_line_price, image: i.image ? i.image + (i.image.includes('?') ? '&' : '?') + 'width=160' : null })) : [],
        discount_codes: cart ? (cart.discount_codes || []).filter((c) => c.applicable).map((c) => c.code) : [],
        subtotal_cents: cart && cart.original_total_price, discount_cents: cart && cart.total_discount,
        discounts: cart ? discounts() : [],
        total_cents: cart ? cart.total_price + ship : null, currency: cart && cart.currency,
      };
    },
  };
  loadCart();
})();
